import { APIService, type APICallbacks } from "@sieg-ad/fetch";
import { useAuthStore } from "~/stores/auth";
import type { Usuario } from "~/types/schemas/usuario";
import { useEscolaStore } from "~/stores/escola";

export class AtlasAPIService extends APIService {
  constructor(options: APICallbacks) {
    super('', options);
  }

  //? `useRuntimeConfig()` exige a instância do Nuxt, que ainda não existe quando este módulo é
  //? avaliado — o middleware global (entry do Nuxt) importa a store de auth, que importa daqui.
  //? A URL é lida na primeira requisição, quando a app já está de pé; todos os verbos passam
  //? por `resolve`, então este é o único ponto a cobrir.
  override async resolve(...args: Parameters<APIService['resolve']>) {
    const self = this as unknown as { baseURL: string };
    if (!self.baseURL) self.baseURL = useRuntimeConfig().public.API_URL;

    return super.resolve(...args);
  }
}

export const API = new AtlasAPIService({
  onRequest: ({ request }) => {
    const escolaStore = useEscolaStore();
    const { escola_id } = storeToRefs(escolaStore);

    if (escola_id.value) {
      request.headers.set('x-escola-id', String(escola_id.value));
    }
  },
  onError({ error }) {
    const authStore = useAuthStore();

    if (error.code === 'SG_AUTH_ERROR') {
      errorToast(error.message);
      authStore.logout();
      return;
    }

    // Rede de segurança: garante feedback mesmo em chamadas sem catch próprio.
    // A duplicação com toasts de catches locais é evitada pelo dedup por
    // toastId (mesma mensagem não reabre) em ~/utils/toast.
    switch (error.type) {
      case 'warn':
        warnToast(error.message);
        break;
      default:
        errorToast(error.message);
    }
  },
  setUser(user: Record<string, any> | null = null) {
    //? O @sieg-ad/fetch tipa o X-User como objeto genérico; o formato é o `AuthUser` da API.
    useAuthStore().setUser(user as Usuario | null);
  },
  getToken() {
    const { token } = storeToRefs(useAuthStore());
    return token.value;
  }
});